import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "../../App.css";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import Api from "../api/api";
import MyLoader from "./loader";
import { ToastContainer } from "react-toastify";

export default (props) => {
  var history = useHistory();

  const [programs, setPrograms] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState(
    props.selectedPrograms
  );
  console.log("selectedPrograms: " + JSON.stringify(selectedPrograms));

  const [loader, setLoader] = useState(false);

  // load data
  useEffect(() => {
    console.log("useEffect");
    loadData();
  }, []);

  const loadData = () => {
    console.log("loadData1");
    let type = "all";
    setLoader(true);
    Api.getAllSpecialPrograms(
      type,
      (response) => {
        setLoader(false);
        if (response.data) setPrograms(response.data);
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  const checkSelectedProgram = (model) => {
    console.log("checkSelectedProgram");
    for (let i = 0; i < selectedPrograms.length; i++) {
      const p = selectedPrograms[i];
      if (p.id + "" === model.id + "") {
        return true;
      }
    }
    return false;
  };

  const addSelectedProgram = (model) => {
    let ps = selectedPrograms.concat(model);
    setSelectedPrograms(ps);
  };

  const removeSelectedProgram = (model) => {
    const ps = selectedPrograms.filter((item, j) => {
      return item.id + "" !== model.id + ""; //false will delete
    });
    setSelectedPrograms(ps);
  };

  const showItem = (model, index) => {
    let className =
      index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
    return (
      <div
        className="item-btn"
        style={{ display: "flex", flexDirection: "column", width: 400 }}
        onClick={(event) => {
          // console.log('click');
          // onCategoryPress(model)
        }}
      >
        <div className={className} style={{ marginTop: 0 }}>
          <div className="projects-item-cat" style={{}}>
            <div style={{ fontSize: 16 }}>{model.title}</div>
          </div>
          <div
            className="projects-item-cat"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <input
              style={{ width: 20, height: 20 }}
              type="checkbox"
              checked={checkSelectedProgram(model)}
              onChange={(event) => {
                console.log(JSON.stringify(event.target.value));
                if (checkSelectedProgram(model)) {
                  removeSelectedProgram(model);
                } else {
                  addSelectedProgram(model);
                }
              }}
              onClick={(event) => {
                event.stopPropagation();
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Popup
      contentStyle={{ width: 500, height: 500 }}
      trigger={props.button}
      modal
      nested
    >
      {(close) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: 0,
            height: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              height: 45,
              width: "100%",
              backgroundColor: "gray",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: "bold", color: "white" }}>
              {props.title}
            </div>
          </div>
          <div
            style={{
              overflow: "scroll",
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <div style={{ marginTop: 15, height: 350 }}>
              {programs.map((model, index) => {
                return showItem(model, index);
              })}
            </div>
          </div>

          <div
            style={{
              padding: 10,
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}
          >
            <Button
              className="btn-block"
              style={{
                backgroundColor: "green",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                props.onDone(selectedPrograms);
                close();
              }}
            >
              Done
            </Button>
            <Button
              className="btn-block"
              style={{
                marginLeft: 15,
                backgroundColor: "red",
                borderWidth: 0,
                width: "50%",
                height: 40,
                fontWeight: "bold",
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                close();
              }}
            >
              Cancel
            </Button>
          </div>
          <MyLoader loader={loader} />
          <div>
            <ToastContainer />
          </div>
        </div>
      )}
    </Popup>
  );
};
